import React, { useContext, useEffect, useState } from "react";
import { SettingsContext } from "./SettingsContext";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import TimePicker from "rc-time-picker";
import UpdatePlanResponse from "./UpdatePlanResponse";
import { getStationCode } from "../../network/NetworkUtil";
import { getRefreshInterval } from "../../overview/utils/utils";
import { getShiftTime } from "../SettingsUtil";
import moment from "moment";

const resetTime = (props) => {
  const { viewModel, dispatch } = useContext(SettingsContext);
  const opsClock = viewModel.opsClockData;
  const settingsDataResetTime = viewModel.resetTime;
  const [resetTime, setResetTime] = useState("");
  const [updatedResetTime, setUpdatedResetTime] = useState("");
  const [defaultClockConfig, setDefaultClockConfig] = useState({});
  const isUserAuthorisedForSettingsEdit =
    props.props.isUserAuthorisedForSettingsEdit;

  useEffect(() => {
    if (doesResetTimeExistsInSettingsData(settingsDataResetTime)) {
      const shiftTimeRangeEndTime =
        settingsDataResetTime.settingsData.shiftTimeRange.endTime;
      const parsedResetTime = getShiftTime(shiftTimeRangeEndTime);
      setResetTime(parsedResetTime);
      setDefaultClockConfig({
        nodeId: getStationCode(),
        resetTime: parsedResetTime,
      });
      const interval = setInterval(() => {
        if (!document.hidden) {
          dispatch({
            type: "FETCH_RESET_TIME",
            data: { dispatcher: dispatch },
          });
        }
      }, getRefreshInterval());
      return () => clearInterval(interval);
    } else if (doesResetTimeExistsInOpsClock(opsClock)) {
      setResetTime(opsClock.defaultClockConfiguration.resetTime);
      setDefaultClockConfig(opsClock.defaultClockConfiguration);
      const interval = setInterval(() => {
        if (!document.hidden) {
          dispatch({
            type: "LOAD_OPS_CLOCK_DATA",
            data: {
              dispatcher: dispatch,
              dispatchDate: new Date().toISOString().slice(0, 10),
            },
          });
        }
      }, getRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [opsClock, settingsDataResetTime]);

  const updateResetTime = () => {
    if (updatedResetTime && resetTime !== updatedResetTime) {
      let updatedClockConfig = {
        ...defaultClockConfig,
        resetTime: updatedResetTime,
      };
      dispatch({
        type: "UPDATE_DEFAULT_CLOCK_CONFIGURATION_REQUEST",
        data: {
          dispatcher: dispatch,
          defaultClockConfiguration: updatedClockConfig,
        },
      });
      setUpdatedResetTime("");
    }
  };

  const onChange = (value) => {
    let newResetTime = value ? value.format("HH:mm") : "";
    setUpdatedResetTime(newResetTime);
  };

  const renderResetTimePicker = () => {
    return (
      <TimePicker
        value={updatedResetTime ? moment(updatedResetTime, "HH:mm") : null}
        showSecond={false}
        timeOnly={true}
        minuteStep={1}
        width={250}
        showIcon={false}
        placeholder="HH:MM"
        onChange={(time) => {
          onChange(time);
        }}
        focusOnOpen={true}
        disabled={!isUserAuthorisedForSettingsEdit}
      />
    );
  };

  return (
    <div>
      <Box type="fill" spacingInset="400">
        <Row alignmentHorizontal={"right"}>
          <Button
            type="primary"
            size={"small"}
            onClick={updateResetTime}
            disabled={!isUserAuthorisedForSettingsEdit}
          >
            Save
          </Button>
        </Row>
      </Box>
      <Table
        headerRows={1}
        showDividers={true}
        spacing="medium"
        showStripes={false}
      >
        <TableRow highlightOnHover={true}>
          <TableCell>Reset Time</TableCell>
          <TableCell>{resetTime}</TableCell>
          <TableCell>{renderResetTimePicker()}</TableCell>
        </TableRow>
      </Table>
      <UpdatePlanResponse />
    </div>
  );
};

const doesResetTimeExistsInOpsClock = (opsClock) => {
  return (
    opsClock &&
    opsClock.defaultClockConfiguration &&
    opsClock.defaultClockConfiguration.resetTime
  );
};

const doesResetTimeExistsInSettingsData = (settingsDataResetTime) => {
  return (
    settingsDataResetTime &&
    settingsDataResetTime.settingsData &&
    settingsDataResetTime.settingsData.shiftTimeRange &&
    settingsDataResetTime.settingsData.shiftTimeRange.endTime &&
    settingsDataResetTime.settingsData.shiftTimeRange.endTime.hour
  );
};

export default resetTime;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ResetTime.js